import QuestionSetService from './QuestionSetService';
import QuestionSetDirective from './QuestionSetDirective';
import 'portalConfig';

export default angular.module('gw-portals-questionsets-angular', ['portal.config']).directive('gwPlQuestionSet', QuestionSetDirective).provider('QuestionSetService', QuestionSetService);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-questionsets-angular/module.js
// module id = 901
// module chunks = 0